export default __webpack_public_path__ + "static/media/profit-and-loss.b2f90313.png";